import { render, staticRenderFns } from "./grandstream.vue?vue&type=template&id=d19ad5ba&scoped=true&"
import script from "./grandstream.vue?vue&type=script&lang=js&"
export * from "./grandstream.vue?vue&type=script&lang=js&"
import style0 from "./grandstream.vue?vue&type=style&index=0&id=d19ad5ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19ad5ba",
  null
  
)

export default component.exports